import React from 'react';
import { motion } from 'framer-motion';

const Reviews = () => {
  return (
    <section id="reviews" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Reviews
          </h2>
          <div className="w-20 h-1 bg-blue-600 rounded-full mx-auto mb-4"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See what our satisfied customers have to say about our painting and power washing services.
          </p>
        </motion.div>

        {/* Reviews Widget */}
        <div 
          id="wid_1752950842233" 
          className="mx-auto" 
          style={{ minHeight: "300px" }}
        ></div>
      </div>
    </section>
  );
};

export default Reviews;